import { useQuery } from "@tanstack/react-query";
import { TableName } from "../../constants/table";
import {
  deleteEntity,
  getAllEntities,
  getFilteredEntities,
} from "../services/api-service";
import { ITenant } from "../../models/tenant";

const stockMasterTableName = TableName.StockMaster;
const tenantTableName = TableName.Tenant;
const companyMasterTableName = TableName.CompanyMaster;
const commonCodeTableName = TableName.CommonCode;
export const fetchStockMaster = async (tenantId: string) => {
  const stockMaster = await getFilteredEntities(stockMasterTableName, tenantId);
  const tenants = await getAllEntities(tenantTableName) as ITenant[];
  const companyMasters = await getAllEntities(companyMasterTableName);
  const commonCodes = await getAllEntities(commonCodeTableName);

  const data = stockMaster.map((item:any , index: number) => {
    const tenantName = tenants.find(
      (e: { PartitionKey: string }) =>
        e.PartitionKey?.toLowerCase() === item.PartitionKey?.toLowerCase()
    )?.RowKey;

    const companyName = companyMasters.find(
      (e: { RowKey: string }) => e.RowKey === item.CompanyId
    )?.CompanyName;

    const vendorName = commonCodes.find(
      (e: { RowKey: string }) => e.RowKey === item.VendorId
    )?.CommonCode;

    return {
      ...item,
      id: index,
      tenantName,
      CompanyName: companyName,
      VendorName: vendorName,
    };
  });

  return data;
};

export const useGetStockMaster = (tenantId: string) =>
  useQuery({
    queryKey: ["fetchStockMaster", tenantId],
    queryFn: async () => fetchStockMaster(tenantId),
  });

export const deleteStockMaster = async (payload: {
  PartitionKey: string;
  RowKey: string;
}) => {
  const { PartitionKey, RowKey } = payload;
  await deleteEntity(stockMasterTableName, PartitionKey, RowKey);
};
